import React, { useState, } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Pay.css';
import logo from '../../img/logo_EAA.png'
import wave from '../../img/wave.jpg'
import om from '../../img/OM.jpg'
import axios from 'axios';
import freemoney from '../../img/free-money.jpg'
import expresso from '../../img/expresso.jpg'
import bank from'../../img/carte-bancaire-50px.svg';
import {Link} from 'react-router-dom';
import { Image, Form,Container,Button,Spinner } from 'react-bootstrap';
import IdTransaction from '../../components/idTransaction/IdTransaction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faDownload } from "@fortawesome/free-solid-svg-icons";
import AlerteMessage from '../../components/AlerteMessage';
import { useEffect } from 'react';
import Input from '../../components/Input';
import InputT from '../../components/Input';
import { InputF } from '../../components/Input';
import guide from '../../docs/Notice_inscription_concours_POLYTECH 2024.pdf'
import brochure from '../../docs/brochure.pdf'
import RecepisseConcours from '../../components/Recepisse';
import UpdateDepot from '../../components/UpdateDepot';
import moment from 'moment';
import Env from '../../hooks/Env';
import video from '../../docs/video-plateforme.mp4'
import demande from '../../docs/Formulair_unique_inscription_concours_EAA.docx'

function Pay ({prix}) {
    const Base_url = Env().API_URL;
    const [bacSerie, setBacSerie] = useState('');
    const [choices, setChoices] = useState({});
    const [totalChoices, setTotalChoices] = useState(0);
    const [firstChoiceType, setFirstChoiceType] = useState('');
    const [data, setData] = useState('');
    const { search } = useLocation();
    const [showPay, setShowPay] = useState(false);
    const maxFileSize = 1024 * 1024 * 3;
    const [complete, setComplete] = useState(false);
    const [requiredOK, setRequiredOk] = useState(true);

    const [selectedFiles, setSelectedFiles] = useState({
        "photo":true,
        "extrait_naissance" : true,
        "autorisation" : true,
        "copie_diplome_licence" : true,
        "certificat_nationnalite" : true,
        "certificat_medical" : true,
        "certificat_nationnalite2" : true,
        "casier" : true,
        "carte_id": true,
        "copie_diplome_bac": true
    });
    const [gestionfichier, setGestionFichier] = useState({  
        "certificat_medical" : false,
        "certificat_nationnalite2" : false,
        "casier" : false,
        "carte_id": false,
        "copie_diplome_bac": false
    });
    const [maxAge, setMaxAge] = useState('');
    const [controllerChoice, setControllerChoice] = useState(false)
    const [errors, setErrors] = useState(false);
    const [step, setStep] = useState(1);
    const [nmbrechoix, setNombreChoix] = useState(false)
    const[ messageAlerte, setMessageAlerte] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [showMessageEmail, setShowMessageEmail] = useState(false);
    const [show, setShow] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [checked, SetChecked] = useState(false);
    const [open, setOpen] = useState (false);
    const [message, setMessage] = useState (false);
    const [valid, SetIsValid] = useState({
        isValidEmail: false,
        isValidPhoneNumber: false,
      });
      const [older,setOlder] = useState(false);
      const [showUpdate, setShowUpdate] = useState(false);
      const handleCloseUpdate = () => {
        setShowUpdate(false);
      }
    const handleChange = (e) => {
        const name= e.target.name;
        let value = e.target.value;
        if (name === 'telephone') {
            const phoneRegex = /^(70|75|76|77|78|71)\d{7}$/;
            const isValidPhoneNumber = phoneRegex.test(value);
        
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: isValidPhoneNumber,
            }));
            setShowMessage(true);
        }
        if (name==="nom") {
            let nom  = value.toUpperCase()
            value = nom
            // console.log(nom)
        }
        if (name==="date_naissance") {
            const referenceDate = moment('2026-12-31');
            const dateNaissance = moment(value); 
            const ageCalcul = referenceDate.diff(dateNaissance, 'years');
            // console.log("Age calculé ",ageCalcul)
            const MaxAge = data.type_concours ==="Officier" ? 21 : 23;
            setMaxAge(MaxAge) ;
            console.log("Age maximum ", maxAge)
          if (ageCalcul > maxAge || ageCalcul < 18) {
            console.log('l\'age minimum est de 18 et 25 au maximum')
            setOlder(true)
            setData({ ...data, [name]: value });
            return
          } else {
            setOlder(false)
          }
        }
        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            SetIsValid((valid) => ({
                ...valid,
                isValidEmail: emailRegex.test(value),
            }));
            setShowMessageEmail(true)
        }
        if (name === 'operateur') {
            SetChecked(e.target.checked)
        }
        setData({ ...data, [name]: value })
    }
    const handleClose3 = () => {
        setOpen(false)
    }
    const [photo, setPhoto] = useState(false);
    const handleFileChange = (event, key) => {
        const elements = document.getElementsByName(key)
        let file = event.target.files[0];
        console.log(key);
        if (key === 'photo') {
            // Autoriser uniquement les images PNG et JPG pour le key 'photo'
            if (file && !(file.type === 'image/jpeg')) {
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                setPhoto(true);
                setOpen(true);
                setMessage("Seuls le format JPG est autorisé pour la photo !");
                event.target.value = '';
                return;
            }
        } else {
            // Autoriser uniquement les PDF pour les autres keys
            if (file && file.type !== 'application/pdf') {
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                setPhoto(true);
                setOpen(true);
                setMessage("Seul le format PDF est autorisé !");
                event.target.value = '';
                return;
            }
        }
        if (file?.size < maxFileSize){
            var filesinfos ;
                if (file.type ==='application/pdf') {
                    if (!data.nom || !data.prenom) {
                    setOpen(true)
                    setMessage("Veuillez renseigner d'abord le nom et prénom !");
                    event.target.value = '';
                    return
                    }
                    data.nom = data.nom.trim()
                    data.prenom = data.prenom.trim()
                    console.log(data.prenom,data.nom)
                    filesinfos = file.slice(0, file.size, 'application/pdf'); 
                    file = new File([filesinfos], `${key+"_"+data.prenom+"_"+data.nom}.pdf`, {type: 'application/pdf'});
                    console.log(file)
                    setPhoto(false)
                    setSelectedFiles((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: file
                    }));
                    setGestionFichier((prevSelectedFiles) => ({
                        ...prevSelectedFiles,
                        [key]: true
                    }));
                    for (var i = 0; i < elements.length; i++) {
                        var element1 = elements[i];
                        element1.style.border = "";
                    }
                } else {
                    if (!data.nom || !data.prenom) {
                        setOpen(true)
                        setMessage("Veuillez renseigner d'abord le nom et prénom !");
                        event.target.value = '';
                        return
                        }
                        data.nom = data.nom.trim()
                        data.prenom = data.prenom.trim()
                        // var filesinfos = file.slice(0, file.size, 'image/jpeg'); 
                        // file = new File([filesinfos], `${infos.codePermanent}.jpeg`, {type: 'image/jpeg'});
                        filesinfos = file.slice(0, file.size, 'image/jpeg'); 
                        file = new File([filesinfos], `${key+"_"+data.prenom+"_"+data.nom}.jpeg`, {type: 'image/jpeg'});
                        console.log(file)
                        setPhoto(false)
                        setSelectedFiles((prevSelectedFiles) => ({
                            ...prevSelectedFiles,
                            [key]: file
                        }));
                        setGestionFichier((prevSelectedFiles) => ({
                            ...prevSelectedFiles,
                            [key]: true
                        }));
                        for (i = 0; i < elements.length; i++) {
                            element1 = elements[i];
                            element1.style.border = "";
                        }
                }   
        } else {
            // console.log('fichier top gros !')
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            for (var j = 0; j < elements.length; j++) {
                var element2 = elements[j];
                element2.style.border = "2px solid #BC0C0C";
                element2.style.transition ='border 0.5s ease-in-out;' // Applique une bordure roug
            }
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setPhoto(true);
            setOpen(true)
            setMessage("Le fichier chargé est supérieur à 1 Mo")
            event.target.value = '';
            return ;
        }
    };
    let NotComplete = true;
    if (!valid.isValidEmail || !valid.isValidPhoneNumber || !checked || older) {
        NotComplete = false;
    }
    const calculateProgress = () => {
        return (step / 2) * 100;
      };
      const handlePreviousStep = () => {
        setStep(step - 1);
      };
      const handleNextStep = () => {
        if (!valid.isValidEmail || !valid.isValidPhoneNumber || !checked) {
            setErrors(true);
            if (!valid.isValidPhoneNumber) {
                setShowMessage(true);
            }
            if (!valid.isValidEmail) {
                setShowMessageEmail(true)
            }
        } else {
            setErrors(false);
            setStep(step + 1);
        }
    };
    const [succes,setSucces] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
       
        const match = search.match(/email=(.*)/);
        const emailFromURL = match?.[1];
        if (emailFromURL){
            axios({
                url:`${Base_url}/paiement/confirmed/`,
                method: 'POST',
                data:{
                    'email':emailFromURL
                }
            })
            .then(result => {
                if (result.data.confirmed_depot === 0) {
                    setDeppotSuccess(true)
                    setSucces(result.data)
                    return
                }
                else if (result.data.campagne==='reinscription' || result.data.campagne==='master') {
                    navigate(`/`);
                }
                 else {
                    navigate('/')
                }
            })
            .catch((error) => {
                console.error(error)
            });
      }
        if (showMessage) {
            const timer = setTimeout(() => {
                setShowMessage(false);
            }, 1000); // 2 seconds
            return () => clearTimeout(timer);
        }
        if (showMessageEmail) {
            const timer = setTimeout(() => {
                setShowMessageEmail(false);
            }, 1000); // 2 seconds
            return () => clearTimeout(timer);
        }

    }, [showMessage, showMessageEmail, choices,data.premier_choix_ecole,data.second_choix_ecole,data.troisieme_choix_ecole,data.quatrieme_choix_ecole,controllerChoice,data,firstChoiceType,data.moyenne_terminal,navigate,search,showPay,bacSerie]);
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const formData = new FormData();
            data.nom = data.nom.trim()
            data.prenom = data.prenom.trim()
            data.type_concours ==="Officier" ? formData.append('campagne',"concours1") : formData.append('campagne',"concours2")
            // formData.append('campagne','concours')
            const nameFiles = ["copie_diplome_bac","certificat_medical","autorisation", "carte_id"];
            for (const i in nameFiles) {
                if (selectedFiles[nameFiles[i]].size) {
                    // console.log('fichier bien rempli')
                    if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                        formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                    } else {
                        // console.log("fichier trop gros");
                    }
                } else {
                    console.log(data.type_candidat, i)
                    if (data.type_candidat ==='militaire' && nameFiles[i]==='autorisation') {
                        console.log("")
                    } else if (data.type_candidat ==='civil' && nameFiles[i]==='autorisation'){
                        console.log("pas obligatoire !")
                    } else {
                        console.log(" dans le else")
                        setPhoto(true);
                        setOpen(true);
                        setMessage("le document "+ nameFiles[i]+ " est obligatoire !");
                        setErrors(true);
                        return
                    }
                }
            }
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    if( data[key] !== null || data[key] !== '') {
                        formData.append(key ,data[key])
                    } else {
                        // console.log(data[key])
                    }
                }
            }
             for (let pair of formData.entries()) {
                // console.log(pair[0] + ':' + pair[1]);
            } 
            const fieldsCount = Array.from(formData.entries()).length;
            // console.log("Champs remplis coorrectement "+fieldsCount)
            if (!valid.isValidPhoneNumber) {
                setMessageAlerte('Incorrect')
                setShow(true);
            }
            else if (!data.type_concours ) {
                setPhoto(true);
                setOpen(true);
                setMessage("les choix sont obligatooire");
            }
            else {
                setErrors(false)
                setComplete(true)
                setSubmitted(true);
                // console.log("Requete en cours d'envoi ...")
                const response = await axios.post(
                    `${Base_url}/paiement/`,
                    formData,
            {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    },
                    });

            if (response.status === 200) {
                setSubmitted(false);
            console.log("Initialisation Success");
            console.log('Data from API :', response.data);
            if (response.data.message==='OK') {
                console.log(response.data)
                setSubmitted(false);
                setShowPay(true);
                setStep(1);
                setData('');
                if (response.data.paymentURL) {
                    window.location.href = response.data.paymentURL;
                }
            }
            else if (response.data.detail) {
                console.log(response.data.detail)
                    setSubmitted(false);
                    setOpen(true);
                    setMessage(response.data.detail)
            }
            } else {
                if (response.data.detail) {
                    // console.log(response.data.detail)
                    setSubmitted(false);
                    setOpen(true);
                    setMessage(response.data.detail)
                }
            }
        }
    } catch (error) {
        setSubmitted(false);
        setOpen(true)
        setMessage('Impossible de procéder à un paiement !')
       console.error('Error ', error);
    }
};
    const handleUpdate = (e) => {
        setShowUpdate(true)
    }
    return (
        <>
        <UpdateDepot showUpdate = {showUpdate} handleCloseUpdate = {handleCloseUpdate} />
        <AlerteMessage open={open} handleClose={handleClose3} message={message} />
        <IdTransaction show={showPay} email={data.email} handleClose={() => 
            {setShowPay(false)}
            } />
        {depotsuccess ? <RecepisseConcours  dataPerson={succes}/> : null}
        <Container className='pay' id='mainConcours'>
            <div className='d-flex flex-row' id='payHead'>
                <div className='text-center' id='texthead'>
                    <h3 className='text-center'>Concours d'Entrée à l'Ecole de l'Armée de l'Air Edition 2026</h3>
                    <h4></h4>
                </div>
            </div>
            <div className='homeConcours'>
                <Form onSubmit={handleSubmit} className=''>
                    <div>
                    <div id="">
                            <p className='ml-2' id='' style={{color:'red', fontSize:'15px'}}>Toute tentative de fraude ou de falsification entraînera l'exclusion immédiate du concours</p>
                    </div>
                    {step === 1 && (
                        <div id='step1Cncours'>
                            <div className='p-4 row' id='headInput'>
                                {/* informations personnelles */}
                                <Form.Group className='col-md-6 col-sm-12'>
                                    <Form.Label style={{color:'#FFD524'}} className='fw-medium'>Numéro de téléphone <span style={{color:'red'}}>*</span> : </Form.Label>
                                    <Form.Control 
                                        placeholder='numero de telephone'
                                        size='md'
                                        type='number'
                                        name='telephone'
                                        className='p-2 custom-email-input'
                                        onChange={handleChange}
                                        value={data.telephone || ''}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className='col-md-6 col-sm-12'>
                                    <Form.Label style={{color:'#FFD524'}} className='fw-medium'>Email <span style={{color:'red'}}>*</span> : </Form.Label>
                                    <Form.Control 
                                        placeholder='Email'
                                        size='md'
                                        type='email'
                                        name='email'
                                        value={data.email || ''}
                                        className='p-2 custom-email-input'
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </div>
                            {showMessage && (
                <span className={`${valid.isValidPhoneNumber ? 'text-success' : 'text-danger'}`}>
                    {valid.isValidPhoneNumber ? 'Numéro valide' : 'Numéro incorrect'}
                </span>
            )}
                            {showMessageEmail && (
                <span className={`${valid.isValidEmail ? 'text-success' : 'text-danger'}`}>
                    {valid.isValidEmail ? 'Email valide' : 'Email incorrect'}
                </span>
            )}
                                {/* {!valid.isValidPhoneNumber ? <span ><i className='alert alert-success w-25 m-2' >Incorrect</i> </span> : <span className='alert alert-success' >Numéro valide</span>} */}
                                {/* alerte fraude */}
                                <div className="alert alert-danger">Les Armées dégagent toute responsabilité quant aux candidats qui choisiraient de passer par des intermédiaires pour les inscriptions en ligne sur la plateforme concours.eaa.sn</div>
                                <div id="labelFrais">
                                    <p className='ml-2' id='frais' style={{color:'#fff', fontSize:'15px'}}>Le paiement des frais de dossier non remboursable est de  (5 000) F. CFA + frais de 100 F. CFA</p>
                                </div>
                            <Form.Group id='operateur'>
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    checked={data.operateur==='wave'}
                                    name="operateur"
                                    value="wave"
                                    label = {
                                        <Image src={wave} height={80} width={80} alt="wave" />
                                    }
                                />
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    checked={data.operateur==='orange-money'}
                                    name="operateur"
                                    value="orange-money"
                                    label = {
                                        <Image src={om} height={80} width={80} alt="orange-money" />
                                    }
                                />
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    name="operateur"
                                    value="free-money"
                                    checked={data.operateur==='free-money'}
                                    label = {
                                        <Image src={freemoney} height={80} width={80} alt="free-money" />
                                    }
                                />
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    name="operateur"
                                    checked={data.operateur==='e-money'}
                                    value="e-money"
                                    label = {
                                        <Image src={expresso} height={80} width={80} alt="e-money" />
                                    }
                                />
                            </Form.Group>
                            <div className="row mt-3 mb-2 justify-content-center">
                            <div className="col-lg-4 col-sm-12">
                                    <Button variant="warning" className='mb-2' size="md" onClick={handleUpdate}>
                                       <span style={{color:'#fff'}}>Modifier candidature</span> 
                                    </Button>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-12">
                                    <a href="https://eaa.sn/2025/12/24/inscription-aux-concours-dentree-a-lecole-de-larmee-de-lair/" target="_blank" rel="noopener noreferrer" style={{textDecoration:'none'}}>
                                        <Button variant="primary" className='w-100' size="md">
                                            Video explicative depot
                                        </Button>
                                    </a>
                            </div>
                            </div>
                            
                        </div>)}
                        
                </div>
                    {/* fin de step 1 */}
                    {step === 2 && (
                        <div id="step2Pay">
                            <Form.Group id='operateur' style={{color:'#FFF'}} className='d-inline mb-2'>
                            <Form.Label style={{color:'#FFD524'}} className='fw-medium'>Type Concours <span style={{color:'red'}}>*</span> :  </Form.Label>
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    name="type_concours"
                                    value="Officier"
                                    checked={data.type_concours==='Officier'}
                                    label="Officier"
                                    // label = {
                                    //     <Image src={freemoney} height={80} width={80} alt="free-money" />
                                    // }
                                />
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    name="type_concours"
                                    checked={data.type_concours==='Sous Officier'}
                                    value="Sous Officier"
                                    label="Sous-Officier"
                                    // label = {
                                    //     <Image src={expresso} height={80} width={80} alt="e-money" />
                                    // }
                                />
                                <Form.Check
                                    inline
                                    onChange={handleChange}
                                    type="radio"
                                    id="wave"
                                    disabled
                                    checked={data.type_concours==='Test Psychotechnique'}
                                    name="type_concours"
                                    value="Test Psychotechnique"
                                    label="Test Psychotechnique"
                                    
                                />
                            </Form.Group>
                            <div className="head">
                                <span className='text-bold'>Informations personnelles</span> 
                            </div>
                           <div className='row infosPerso' id='test'>
                           <Form.Group>
                            </Form.Group>
                                <Form.Group>
                                    <div className='d-inline' style={{color:'#FFF'}}>
                                        <Form.Check
                                        inline
                                                type="radio"
                                                label="Monsieur"
                                                value="M"
                                                required
                                                checked={data.civilite==='M'}
                                                name="civilite"
                                                onChange={handleChange}
                                            />
                                    </div>
                                    <div className='d-inline' style={{color:'#FFF'}}>
                                            <Form.Check
                                            checked={data.civilite==='F'}
                                                inline
                                                type="radio"
                                                label="Madame"
                                                value="F"
                                                required
                                                name="civilite"
                                                onChange={handleChange}
                                            />
                                    </div>
                                </Form.Group>
                            <div>
                            </div>
                                <Input className="col-md-6 col-sm-12" value={data.prenom || ''}  type='text' label="Prénom (s)" name='prenom' onChange={handleChange} />
                                <Input className="col-md-6 col-sm-12" value={data.nom || ''}   type='text' label="Nom" name='nom' onChange={handleChange}/>
                                <Input type='date' className='col-md-6 col-sm-12' label="Date de Naissance (jour/mois/année)" name='date_naissance' value={data.date_naissance || ''} onChange={handleChange} />
                                {older ? <span style={{color:'#fff'}}>Le concours est ouvert aux candidats âgés de 18 ans au moins et de {maxAge} ans au plus </span>: null}
                                <Input type='text' className='col-md-6 col-sm-12' label="Lieu de Naissance" name='lieu_naissance' value={data.lieu_naissance} onChange={handleChange} />
                                <Input type='text' className='col-md-6 col-sm-12' label="Adresse" name='address' value={data.address} onChange={handleChange} />
                                <Input type='text' className='col-md-6 col-sm-12'  label="Numéro d'Identification Nationnale (NIN)" name='nin' value={data.nin} onChange={handleChange} /> <br />
                            </div>
                            <div className="row">
                                
                            </div>
                           
                            <div className="head">
                            <span className='text-bold'>Informations du concours</span> 
                            </div>
                            <div >
                                 {data.type_concours === "Sous Officier" ?
                                    <Form.Group id="serie_candidat" >
                                        <Form.Label style={{color:'#FFD524'}} className='fw-medium'>Série du Baccalauréat<span style={{color:'red'}}>*</span></Form.Label>
                                        <Form.Select name='serie_candidat' required value={data.serie_candidat} onChange={handleChange}>
                                            <option value="">--- Veuillez choisir une Option  ---</option>
                                            <option value="Sciences">Sciences</option>
                                            <option value="Lettres">Lettres</option>
                                        </Form.Select>
                            </Form.Group>
                             : null  
                    }
                            <Form.Group id='serie'>
                                <Form.Label style={{color:'#FFD524'}} className='fw-medium'>Type Candidat<span style={{color:'red'}}>*</span></Form.Label>
                                <Form.Select name='type_candidat' required value={data.type_candidat} onChange={handleChange}>
                                    <option value="">---Veuillez choisir un type ---</option>
                                    <option value='civil'>Civil</option>
                                    <option value='militaire'>Militaire</option>
                                </Form.Select>
                            </Form.Group>
                            {data.type_candidat ==='militaire' ?<Input type='text' className='col-md-6 col-sm-12' label="Matricule" name='matricule' value={data.matricule} onChange={handleChange} /> : null}
                                </div>
                                <Form.Group>
                                <Form.Label style={{color:'#FFD524'}} className='fw-medium'>Choix du Centre d'examen(Ecrit) <span style={{color:'red'}}>*</span></Form.Label>
                                <Form.Select name='centre_examen' required value={data.centre_examen} onChange={handleChange}>
                                    <option value="">--- Veuillez choisir un centre ---</option>
                                    <option value="Dakar">Dakar</option>
                                    <option value="Kaolack">Kaolack</option>
                                    <option value="Saint-Louis">Saint-Louis</option>
                                    <option value="Thies">Thies</option>
                                    <option value="Ziguinchor">Ziguinchor</option>
                                </Form.Select>
                                </Form.Group>                                        
                            {controllerChoice ? <div className="alert alert-danger" role="alert">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Vous devez choisir au moins une dans chaque département.
                                </div> : 
                            null}
                            {nmbrechoix && (
                            <div className="alert alert-warning" role="alert">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                    </svg> Vous devez choisir au moins deux filières .
                                </div>
                            )}
                            <div className="head">
                                <span className='text-bold'>Dossiers à fournir</span> 
                            </div>
                                <div id="files">

                                    <Form.Group className="mb-2 mt-2">
                                        <div className="d-flex justify-content-between align-items-start">
                                            <Form.Label style={{color:'#FFD524'}} className='fw-medium'>Formulaire de Demande adressée au ministre des Forces armées <span style={{color:'red'}}>*</span></Form.Label>
                                            <a href={demande} download className="btn btn-outline-light btn-sm ms-2 download-model-btn" style={{textDecoration: 'none'}}>
                                                <FontAwesomeIcon icon={faDownload} className="me-1" />
                                                Télécharger le formulaire
                                            </a>
                                        </div>
                                        <Form.Control
                                            className="rounded-left mb-2"
                                            size='md'
                                            accept='.pdf,.png,.jpeg,.jpg'
                                            type='file'
                                            name='autorisation'
                                            required={true}
                                            onChange={(e) => handleFileChange(e,"autorisation")}
                                        />
                                    </Form.Group>
                                    {!selectedFiles["autorisation"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo Veuillez le réduire . </span>: null}
                                    <InputF required={true} className="rounded-left mb-2" label="photocopie de la carte nationale d'identité sénégalaise" type='file' name='carte_id' onChange={(e) => handleFileChange(e,"carte_id")} />
                                    {!selectedFiles["carte_id"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo Veuillez le réduire . </span>: null}
                                    {/* <InputF required={true} className="rounded-left mb-2" label="copie légalisée du certificat de nationalité sénégalaise " type='file' name='certificat_nationnalite' onChange={(e) => handleFileChange(e,"certificat_nationnalite")} />
                                    {!selectedFiles["certificat_nationnalite"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo Veuillez le réduire . </span>: null} */}
{/* 
                                    <InputF required={true} className="rounded-left mb-2" label="Extrait de naissance de moins de 3 mois" type='file' name='extrait_naissance' onChange={(e) => handleFileChange(e,"extrait_naissance")} />
                                    {!selectedFiles["extrait_naissance"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo Veuillez le réduire . </span>: null} */}

                                    {/* <InputF required={true} className="rounded-left mb-2" label="Photo d'identité" type='file' name='photo' onChange={(e) => handleFileChange(e,"photo")} />
                                    {!selectedFiles["photo"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo Veuillez le réduire . </span>: null}
                                     */}
                                    {/* <InputF required={true} className="rounded-left mb-2" label="casier judiciaire n°3 datant de moins de trois mois " type='file' name='casier' onChange={(e) => handleFileChange(e,"casier")} />
                                    {!selectedFiles["casier"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo Veuillez le réduire . </span>: null} */}

                                    <InputF required={true} className="rounded-left mb-2" label="Copie certifiée conforme d'une attestation, diplôme ou relevé de note du Baccalauréat ou certificat d'inscription en Terminale" type='file' name='copie_diplome_bac' onChange={(e) => handleFileChange(e,"copie_diplome_bac")} />
                                    {!selectedFiles["copie_diplome_bac"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo Veuillez le réduire . </span>: null}

                                    <InputF required={true}  className="rounded-left mb-2" label="certificat d'aptitude médicale datant de moins de trois mois, délivré par un médecin militaire et attestant du profil exigé " type='file' name='certificat_medical' onChange={(e) => handleFileChange(e,"certificat_medical")} />
                                    {!selectedFiles["certificat_medical"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo Veuillez le réduire . </span>: null}
{/* 
                                    <InputF required={true} id="bulletin" className="rounded-left mb-2" label="Bulletin Seconde deuxieme semestre" type='file' name='certificat_nationnalite2' onChange={(e) => handleFileChange(e,"certificat_nationnalite2")} />
                                    {!selectedFiles["certificat_nationnalite2"]? <span style={{color:'red'}}>taille du fichier {'>'} 1 Mo Veuillez le réduire . </span>: null} */}
                                </div>
                        </div>
                    )}
                    {/* Fin de step 2 */}
                    {errors ? <><div className="alert alert-danger" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Veuilez remplir tous les champs
                            </div></> : null}
                            <div id="buttonsPay">
                    {step > 1 && (
                    <Button variant='primary' className='float-start' size="md" onClick={handlePreviousStep}>Précedent</Button>
                    )}
                    {step < 2 && (
                <Button className='float-end mb-2' variant='primary' size="md" onClick={handleNextStep}>Suivant</Button>
            )}
                    {step === 2 && 
                        <Button
                            size='md'
                            variant='primary' 
                            disabled={!valid.isValidEmail || !valid.isValidPhoneNumber || !checked || older  || photo ||  !requiredOK || controllerChoice || nmbrechoix}
                            type='submit'
                            role='submit'
                            className ='float-end btn-submit '
                            >
                                {requiredOK ? (<span>Payer avec {data.operateur}</span>)  : <FontAwesomeIcon icon={faBan} className='color-logo' />} 
                                {submitted ? 
                                    <Spinner animation="grow"
                                        size="sm" role="status"
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner> 
                                : null} 
                        </Button>  }
                    </div>
                </Form>
            </div>
        </Container>
        </>
    )
}
export default Pay